import { render, staticRenderFns } from "./apiaccess_modal.vue?vue&type=template&id=449536a7&scoped=true&"
import script from "./apiaccess_modal.vue?vue&type=script&lang=js&"
export * from "./apiaccess_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449536a7",
  null
  
)

export default component.exports